export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  const pfx = 'emp-ticker';
  const style = `<style>
    .${pfx} {
        height: 8vh;
        line-height: 8vh;
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: 700;
        background-color: #F44336;
        color: #ffffff;
        font-size: 2.8vh;
        z-index: 999;
     } 
  </style>`;
  const textLoading = config.translate.loading;

  bm.add('ticker', {
    label: 'Ticker',
    category: 'Text',
    content: `<div class="${pfx}" data-gjs-type="ticker">
                <div id="newsTicker" class="breaking-news-ticker" >
                   <div class="bn-news">
                    <ul>
                      <li><span class="bn-loader-text">${config.translate.loading}</span></li>
                    </ul>
                  </div>
                  <div class="bn-controls">
                      <button>
                          <span class="bn-arrow bn-prev"></span>
                      </button>
                      <button><span class="bn-action"></span></button>
                      <button>
                          <span class="bn-arrow bn-next"></span>
                      </button>
                  </div>
                </div>
              </div>
              ${style}
            `,
    attributes: {
      class: 'icon-news', //icon in the panel
    },
  });
};



// WEBPACK FOOTER //
// ./src/plugins/ticker/blocks.js